<template>
    <div style="background-color:#FFF;">
        <section>
            <div class="row mt-3">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <CLoader :pConfigLoad="ConfigLoad">
                        <template slot="BodyFormLoad">
                            <main class="main-content mt-0">
                                <section>
                                    <div class="page-header min-vh-100">
                                        <div class="container">
                                            <div class="row">
                                                <div class="col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0 mx-auto">
                                                    <div class="card card-plain">
                                                        <div class="card-header pb-0 text-start">
                                                            <h4 v-if="Visible" class="font-weight-bolder">Encuesta de {{VisibleCoordinador ? 'Coordinadores' : 'Parejas'}}</h4>
                                                            <p v-if="Visible">Por favor conteste la siguiente encuesta, queremos conocer su opinión acerca de nuestro servicio.</p>
                                                            <h4 v-if="!Visible">{{ TxtDefault }}</h4>
                                                            <!-- <h4 v-if="Visible" class="font-weight-bolder">Por favor conteste la siguiente encuesta, queremos conocer su opinión acerca de nuestro servicio.</h4> -->
                                                        </div>
                                                        <div class="card-body">
                                                            <Form role="form">
                                                                <div class="mb-3" v-if="Visible && VisibleCoordinador">
                                                                    <button @click="IrAEncuesta('ESP')" class="btn btn-lg btn-primary btn-lg w-100 mt-4 mb-0" type="button">Contestar Encuesta</button>
                                                                </div>
                                                                <div v-if="Visible && VisibleParejas">
                                                                    <p class="mb-0">Seleccione un Idioma</p>
                                                                    <div class="form-check">
                                                                        <input type="radio" class="form-check-input" v-model="SeleccionIdioma" value="ESP" id="ESP"/>
                                                                        <label for="ESP" class="form-check-label">Español</label>
                                                                    </div>
                                                                    <div class="form-check">
                                                                        <input type="radio" class="form-check-input" v-model="SeleccionIdioma" value="ENG" id="ENG"/>
                                                                        <label for="ENG" class="form-check-label">Inglés</label>
                                                                    </div>
                                                                    <button :disabled="SeleccionIdioma==''" @click="IrAEncuesta(SeleccionIdioma)" type="button" class="btn btn-lg btn-primary btn-lg w-100 mt-4 mb-0">Responder Encuesta</button>
                                                                </div>
                                                            </Form>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-6 d-lg-flex d-none h-100 my-auto pe-0 position-absolute top-0 end-0 text-center justify-content-center flex-column">
                                                    <div class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden" style="background-image: url('https://www.esneca.com/wp-content/uploads/eventos-sociales-1200x720.jpg');background-size: cover;">
                                                        <span class="mask bg-gradient-primary opacity-6"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </main>
                            <!-- <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-4 m-auto">
                                            <h4 v-if="Visible">Por favor conteste la siguiente encuesta, queremos conocer su opinión acerca de nuestro servicio.</h4>
                                            <div v-if="Visible && VisibleCoordinador">
                                                <button @click="IrAEncuesta('ESP')" class="btn btn-primary" type="button">Contestar Encuesta</button>
                                            </div>
                                            <div v-if="Visible && VisibleParejas">
                                                <div class="form-check">
                                                    <input type="radio" class="form-check-input" v-model="SeleccionIdioma" value="ESP" id="ESP">
                                                    <label for="ESP" class="form-check-label">Español</label>
                                                </div>
                                                <div class="form-check">
                                                    <input type="radio" class="form-check-input" v-model="SeleccionIdioma" value="ENG" id="ENG">
                                                    <label for="ENG" class="form-check-label">Inglés</label>
                                                </div>
                                                <button :disabled="SeleccionIdioma==''" @click="IrAEncuesta(SeleccionIdioma)" class="btn btn-primary" type="button">Contestar Encuesta</button>
                                            </div>
                                            <h4 v-if="!Visible">{{ TxtDefault }}</h4>
                                        </div>
                                        <div class="col-lg-8">
                                            <img class="img img-responsive img-thumbnail" src="https://www.esneca.com/wp-content/uploads/eventos-sociales-1200x720.jpg" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </template>
                    </CLoader>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

import Configs from '@/helpers/VarConfig.js';
export default {
    name:'ResponderEncuesta',
    props:[''],
    data() {
        return {
            ConfigLoad:{
				ShowLoader: true,
				ClassLoad:  false,
			},
            MasterKey:'',
            MasterId:'',
            SendDate:'',
            Rol:'',
            IdEmpresa:'',
            IdSucursal:'',
            SeleccionIdioma:'',
            TxtDefault:'Lo sentimos pero el link no es válido o ya expiro, por favor solicite una nueva encuesta.',
            Visible:true,
            VisibleParejas:false,
            VisibleCoordinador:false
        }
    },
    methods: {
        ValidaToken(){
            // let request={
            //     Key:this.MasterKey,
            //     Id:this.MasterId,
            //     KeyNum:this.MasterNum,
            //     Rol:this.Rol
            // }
            let formData=new FormData();
            formData.set('Key',this.MasterKey);
            formData.set('Id',this.MasterId);
            formData.set('KeyNum',this.MasterNum);
            formData.set('Rol',this.Rol);
            this.$http.post('configEncuestasValidar',formData
            ).then((res)=>{
                this.Visible=true;
                this.ConfigLoad.ShowLoader=false;
                this.SendDate=res.data.data;
                if (this.Rol=='COORDINADOR') {
                    this.VisibleCoordinador=true;
                }
                else{
                    this.VisibleParejas=true;
                    this.ConfigLoad.ShowLoader=false;
                }
            }).catch((err)=>{
                this.Visible=false;
                this.TxtDefault=err.response.data.message;
                this.ConfigLoad.ShowLoader=false;
            })
        },
        IrAEncuesta(Idioma){
            // if (this.Rol=='COORDINADOR') {
            //     this.$router.push(
            //         {
            //             name:'encuestaResueltaCoordinador',
            //             params:{
            //                 Id:'',
            //                 IdEmpresa:this.IdEmpresa,
            //                 IdSucursal:this.IdSucursal,
            //                 FechaEnvio:new Date(this.SendDate),
            //                 IdResponde:this.MasterId,
            //             }
            //         });
            // }
            this.$router.push({
                name:'encuestaResueltaCoordinador',
                params:{
                    Id:'',
                    IdEmpresa:this.IdEmpresa,
                    IdSucursal:this.IdSucursal,
                    FechaEnvio:new Date(this.SendDate),
                    IdResponde:this.MasterId,
                    TipoEncuesta:this.Rol,
                    Idioma:Idioma,
                    Token:this.MasterNum
                }
            });
        },
        IrALogin(){

        }
    },
    created() {
        this.MasterKey=this.$route.params.key;
        this.MasterId=this.$route.params.id;
        this.MasterNum=this.$route.params.num;
        this.Rol=this.$route.params.rol;
        this.IdEmpresa=this.$route.params.emp;
        this.IdSucursal=this.$route.params.suc;
        this.ValidaToken();
    },
}
</script>

<style>
    
</style>